var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items)?_c('menu-items',{attrs:{"items":_vm.items,"parentID":null,"onExpandMenu":_vm.handleGetData,"onShowMore":_vm.handleShowMore,"count":_vm.actualCount,"total":_vm.total}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }